import React, { useState } from "react";
import { handleRequest } from "../utils/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale";

const WithdrawLimit = ({ password, setPassword, setMessage }) => {
  const [phone, setPhone] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isUnlock, setIsUnlock] = useState(false);

  // 날짜 포맷 함수 (화면 표시용): Date -> "25.07.10 11:45"
  const formatDateTime = (date) => {
    if (!date) return "";
    const year = String(date.getFullYear()).slice(2);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}.${month}.${day} ${hours}:${minutes}`;
  };

  // API 전송용 날짜 포맷: Date -> "2025-12-01 00:00:00"
  const formatDateTimeForAPI = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:00`;
  };

  const handleSubmit = async () => {
    if (!password) {
      alert("비밀번호를 입력해주세요.");
      // setMessage("비밀번호를 입력해주세요.");
      return;
    }

    if (!phone) {
      alert("핸드폰 번호를 입력해주세요.");
      // setMessage("핸드폰 번호를 입력해주세요.");
      return;
    }

    if (!isUnlock && (!startDate || !endDate)) {
      alert("시작일과 종료일을 선택해주세요.");
      // setMessage("시작일과 종료일을 선택해주세요.");
      return;
    }

    const action = isUnlock ? "해제" : "설정";
    const userConfirmed = window.confirm(
      `${phone} 회원의 출금제한을 ${action}하시겠습니까?`
    );
    if (!userConfirmed) {
      return;
    }

    try {
      const response = await handleRequest("/admin/lockWithdraw", {
        phone: phone,
        adminPassword: password,
        lockTimeStart: isUnlock ? "" : formatDateTimeForAPI(startDate),
        lockTimeEnd: isUnlock ? "" : formatDateTimeForAPI(endDate),
        isUnlock: isUnlock ? "true" : "false",
      });

      if (response.status === "error") {
        alert("에러: " + (response.message || "알 수 없는 오류가 발생했습니다."));
        // setMessage("에러: " + (response.message || "알 수 없는 오류가 발생했습니다."));
        return;
      }

      if (response.status === "success" || !response.status) {
        alert(`출금제한이 성공적으로 ${action}되었습니다.`);
        // setMessage(`출금제한이 성공적으로 ${action}되었습니다.`);
        setPhone("");
        setPassword("");
        setStartDate(null);
        setEndDate(null);
        setIsUnlock(false);
      } else {
        alert("출금제한 설정 중 오류가 발생했습니다.");
        // setMessage("출금제한 설정 중 오류가 발생했습니다.");
        setPassword("");
      }
    } catch (error) {
      console.error("출금제한 설정 중 오류 발생:", error);
      let errorMsg = "";
      if (error.response?.data?.error) {
        errorMsg = String(error.response.data.error);
      } else if (error.response?.data?.message) {
        errorMsg = String(error.response.data.message);
      } else if (error.message) {
        errorMsg = String(error.message);
      } else {
        errorMsg = "알 수 없는 오류가 발생했습니다.";
      }
      alert("출금제한 설정 중 오류가 발생했습니다: " + errorMsg);
      // setMessage("출금제한 설정 중 오류가 발생했습니다: " + errorMsg);
    }
  };

  return (
    <div className="withdraw-limit-area">
      <div className="sub-tit-area">
        <div className="dot-container">
          <span className="dot outer"></span>
          <span className="dot inner"></span>
        </div>
        <p>회원 출금제한</p>
      </div>
      <div className="input-area">
        <div className="input-wrapper">
          <span className="label body-n d-gray">
            핸드폰 번호&nbsp;&nbsp;&nbsp;&nbsp;|
          </span>
          <input
            type="text"
            id="phone"
            className="inp3 body-n"
            placeholder=""
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div className="input-wrapper date-wrapper">
          <img src="/img/calendar-icon.png" alt="calendar" className="calendar-icon" />
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={10}
            dateFormat="yy.MM.dd HH:mm"
            locale={ko}
            placeholderText="시작일 선택"
            className="inp3 body-n date-input"
            disabled={isUnlock}
            onChangeRaw={(e) => e.preventDefault()}
          />
        </div>
        <div className="input-wrapper date-wrapper">
          <img src="/img/calendar-icon.png" alt="calendar" className="calendar-icon" />
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={10}
            dateFormat="yy.MM.dd HH:mm"
            locale={ko}
            placeholderText="종료일 선택"
            className="inp3 body-n date-input"
            disabled={isUnlock}
            onChangeRaw={(e) => e.preventDefault()}
          />
        </div>
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            id="isUnlock"
            checked={isUnlock}
            onChange={(e) => setIsUnlock(e.target.checked)}
          />
          <label htmlFor="isUnlock">출금제한 해제</label>
        </div>
      </div>
      <div className="button-area">
        <button className="solid m-button" onClick={handleSubmit}>
          제한 설정
        </button>
      </div>
    </div>
  );
};

export default WithdrawLimit;
